<template>
<w-sliding-popup ref="slidingPopup" title="관련 이벤트 정보" width="1000px">
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="end">
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper ref="taskTable" border :data="tableDatas" :columns="columns" :show-custom-header="true"
      :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :column-default="columnDefault">
    </el-table-wrapper>
  </div>
</w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import logApi from '@/api/virtual/performance/log';

export default {
  name: 'WVcenterLogEventPopup',
  data() {
    return {
      tableDatas: [],
      columnDefault,
      showSearchTool: false,
      columns: [
        { label: '설명', prop: 'message', width: '500px', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '대상', prop: 'objName', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '날짜 시간', prop: 'timestamp', width: '150px', sortable: true, formatter: this.getDateFormatter },
      ],
      EMPTY_TEXT,
    };
  },
  methods: {
    open(params) {
      this.$refs.slidingPopup.visible = true;
      this.loadData(params);
    },
    loadData(params) {
      logApi.getVcenterLogByHistType(params).then((response) => {
        if (response.data.success) {
          this.tableDatas = response.data.data;
          this.tableTotal = response.data.total;
        }
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value) && value !== '') {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VcenterLogEventPopup.vue